import React from 'react'
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

const Section4 = () => {
  const { t } = useTranslation();

  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.1,
        ease: "easeInOut"
      },
    },
    exit: {
      transition: { duration: 0, delay: 0 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 100 },
    visible: { opacity: 1, y: 0, transition: { duration: 1 , ease: "easeInOut"} },
    exit: { opacity: 0, y: 20, transition: { duration: 0, delay: 0 } },
  };

  const photoVariants = {
    initial: { scale: 1.2, transition: { duration: 3, ease: "easeInOut" } },
    whileInView: { scale: 1, transition: { duration: 3, ease: "easeInOut" } },
    exit: { scale: 1.2, transition: { duration: 0, delay: 0 } },
  };

  return (
    <motion.div className='grid grid-cols-10  pt-14  '
    initial="hidden"
    whileInView="visible"
    exit="exit"
    variants={containerVariants}
    >
        <div className='col-start-2 col-span-8  grid  grid-cols-2 '>
            <div>
                <motion.h1 variants={itemVariants} className=' text-65 font-thin text-customYellow mb-5 tracking-widest'>{t("home.certificates.title")}</motion.h1>

                <motion.p variants={itemVariants} className='text-20 font-light text-customGray'>{t("home.certificates.text")}</motion.p>
            </div>
        </div>
    </motion.div>
  )
}

export default Section4
